var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.toasts),function(toast){return _c('span',{key:toast.id},[_c('Toast',{attrs:{"toast":toast},on:{"removeToast":_vm.onRemove}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }